/**
 * Default coordinate transformation for all charts.
 */
export const Cartesian = () => [['cartesian']];
Cartesian.props = {};
//# sourceMappingURL=cartesian.js.map